import { TableRow, TableCell, Checkbox } from '@occc-app/design-system';
import { RetailerNetworkLocationGroupFragment } from '@occc/graphql';

type RetailerNetworkUserDetailsLocationGroupTableRowProps = {
  locationGroup: RetailerNetworkLocationGroupFragment;
  isItemSelected: boolean;
  handleItemSelect: (id: string) => void;
};

export const RetailerNetworkUserDetailsLocationGroupsTableRow = ({
  locationGroup,
  isItemSelected,
  handleItemSelect,
}: RetailerNetworkUserDetailsLocationGroupTableRowProps) => {
  const locationName = locationGroup?.name || '';
  const countOfLocations = locationGroup?.countOfLocations || '';

  return (
    <TableRow key={locationGroup.uuid} selected={isItemSelected}>
      <TableCell padding='checkbox'>
        <Checkbox
          checked={isItemSelected}
          onClick={(event) => {
            event.stopPropagation();
            handleItemSelect(locationGroup.uuid);
          }}
        />
      </TableCell>
      <TableCell>{locationName}</TableCell>
      <TableCell>{countOfLocations}</TableCell>
    </TableRow>
  );
};
